import IDBStorage from './IDBStorage';
import LocalStorage from './LocalStorage';

let storage = null;

if (IDBStorage.isSupported()) {
  storage = IDBStorage;
} else {
  storage = LocalStorage;
}

export default storage;
